import { InputType } from "@/helpers/types/types.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";
import { ExtendedOption } from "@/stores/EngineStore/interfaces/ExtendedOption.ts";

export const updateOptionsHelper = (state: EngineStoreData, newOption: ExtendedOption, itemId: string) => ({
  cartAccommodationItems: state.cartAccommodationItems?.map((CAI) => {
    if (CAI.id === itemId) {
      const index = CAI.optionalExtras.findIndex((o) => o.id === newOption.id);

      // If the newOption's value is 0, remove the option
      if (newOption.value === 0) {
        return { ...CAI, optionalExtras: CAI.optionalExtras.filter((o) => o.id !== newOption.id) };
      }

      // If the newOption's id matches existing, update it, otherwise, add the newOption
      if (index !== -1) {
        const newOptions = [...CAI.optionalExtras];
        newOptions[index] = {
          ...newOption,
          value: newOption.inputType === InputType.NumberSelect ? newOption.value : 1,
        };
        return { ...CAI, optionalExtras: newOptions };
      } else {
        return { ...CAI, optionalExtras: [...CAI.optionalExtras, newOption] };
      }
    }
    return CAI;
  }),
});
